import React from "react";
import { Link } from "react-router-dom";

const galleryImages = [
  "1.jpg",
  "2.jpg",
  "3.jpg",
  "4.jpg",
  "5.jpg",
  "6.jpg",
  "7.jpg",
  "8.jpg",
  "9.jpg",
  "10.jpg",
  "11.jpg",
  "12.jpg",
];

const getColumnClass = (index) => {
  // FIRST ROW (0,1,2) -> 5 4 3
  if (index < 3) {
    return index === 0
      ? "col-lg-5"
      : index === 1
      ? "col-lg-4"
      : "col-lg-3";
  }

  // SECOND ROW (3,4,5) -> 4 4 4
  if (index >= 3 && index < 6) {
    return "col-lg-4";
  }

  // THIRD ROW (6,7,8) -> 4 4 4
  if (index >= 6 && index < 9) {
    return "col-lg-4";
  }

  // LAST ROW (9,10,11) -> 5 4 3
  if (index >= 9) {
    return index === 9
      ? "col-lg-4"
      : index === 10
      ? "col-lg-5"
      : "col-lg-3";
  }

  return "col-lg-4";
};

const GallerySection = () => {
  return (
    <div className="gallery-section section-padding fix bg-color2">
      <img alt="shape" className="menu_animation1" src="assets/img/shape/chefeShape1_1.png"></img>
      <div className="container">
        <div className="row gy-4">
          {galleryImages.map((img, index) => (
            <div key={index} className={getColumnClass(index)}>
              <div className="gallery-thumb style2">
                <Link to="/menu">
                  <img
                    src={`/assets/img/gallery/${img}`}
                    alt="thumb"
                    className="img-fluid"
                  />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
          <img alt="shape" className="menu_animation" src="assets/img/shape/popularDishesShape1_1.png"></img>  
    </div>
  );
};

export default GallerySection;
